import { ChevronDown } from "lucide-react";
import type { Locale, RouteKind } from "../content/types";
import { routePath } from "../assets/routes";
import { localeLabels, localizedPaths, locales } from "../i18n/routes";

type LanguageSwitcherProps = {
  locale: Locale;
  context?: RouteKind;
  onSwitch?: (to: Locale) => void;
};

// 三种语言用一个透明的原生 select 盖在按钮上：外观沿用原来的胶囊，展开列表、键盘和移动端选择器交给浏览器。
// 选中后整页跳转到预渲染好的目标页（与原来的 <a> 行为一致）。
export function LanguageSwitcher({ locale, context = "landing", onSwitch }: LanguageSwitcherProps) {
  return (
    <span className="language-switch">
      <span aria-hidden="true">{localeLabels[locale]}</span>
      <ChevronDown size={14} aria-hidden="true" />
      <select
        className="language-switch-select"
        aria-label="Switch language"
        value={locale}
        onChange={(event) => {
          const to = locales.find((candidate) => candidate === event.target.value);
          if (!to || to === locale) return;
          onSwitch?.(to);
          window.location.assign(routePath(localizedPaths[context][to]));
        }}
      >
        {locales.map((option) => (
          <option key={option} value={option}>
            {localeLabels[option]}
          </option>
        ))}
      </select>
    </span>
  );
}
